import React from "react";
import { useSelector } from "react-redux";
import { selectPrimaryExistingRegistration } from "../../../../../redux/slices/existingRegistrationsSlice";
import ReturningRegistrationBanner from "./ReturningRegistrationBanner";

const ConnectedReturningRegistrationBanner = () => {
    const primaryExistingRegistration = useSelector(
        selectPrimaryExistingRegistration,
    );
    const isVisible = Object.keys(primaryExistingRegistration).length > 0;

    return <ReturningRegistrationBanner isVisible={isVisible} />;
};

export default ConnectedReturningRegistrationBanner;
